export default "__VITE_ASSET__b94f5ce0__"